/* eslint-disable no-unused-vars */
import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { axiosBaseQuery } from '../axios/index';
import { addFieldStatus } from 'utils';

export const manageAppsAPI = createApi({
  reducerPath: 'ManageAppsAPI',
  baseQuery: axiosBaseQuery({ baseUrl: '/api/AppsManage' }),
  tagTypes: [
    'AppsManage/GetAppAdvancedData',
    'AppsManage/GeneralSettings',
    'AppsManage/GetAppsToPromoteByFiltere',
    'AppsManage/GetPlacements',
    'AppsManage/GetPublisherApps',
  ],
  endpoints: (build) => ({
    // fetchAppsList: build.query({
    //   query: () => ({
    //     url: `/GetAppsToPromote`,
    //   }),
    //   providesTags: ['AppsManage/GetAppsToPromote'],
    //   transformResponse: (response) => {
    //     // const appList = response?.filter(({ pba_url1 }) => pba_url1);
    //     const appList = response;
    //     return addFieldStatus(appList);
    //   },
    // }),
    // fetchWebAppsList: build.query({
    //   query: () => ({
    //     url: `/GetWebAppsToPromote`,
    //   }),
    //   providesTags: ['AppsManage/GetWebAppsToPromote'],
    //   transformResponse: (response) => {
    //     const appList = response;
    //     return addFieldStatus(appList);
    //   },
    // }),
    fetchAppsToPromoteByFilter: build.query({
      query: (isWebSelection) => ({
        url: `/GetPublisherAppsByFilter`,
        params: {
          isWebSelection,
        },
      }),
      providesTags: ['AppsManage/GetAppsToPromoteByFiltere'],
      transformResponse: (response) => {
        const appList = response;
        return addFieldStatus(appList);
      },
    }),
    GetAppsList: build.query({
      query: () => ({
        url: `/GetPublisherApps`,
      }),
      providesTags: ['AppsManage/GetPublisherApps'],
      transformResponse: (response) => {
        // const appList = response?.filter(({ pba_url1 }) => pba_url1);
        const appList = response;
        return addFieldStatus(appList);
      },
    }),
    FetchAppAdvancedData: build.query({
      query: ({ pba_id }) => ({
        url: `/GetAppAdvancedData`,
        params: {
          pba_id,
        },
      }),
      providesTags: () => ['AppsManage/GetAppAdvancedData'],
      transformResponse: (response, meta, arg) => {
        const { isAdvertiser } = arg;
        const newResponse = structuredClone(response);
        if (isAdvertiser) {
          newResponse.excluded_publishers = structuredClone(response.excluded_advertisers);
          delete newResponse.excluded_advertisers;
        }
        return newResponse;
      },
    }),
    fetchSerachAdvertisers: build.query({
      query: (term) => ({
        url: `/GetSearchAdvertisers`,
        params: {
          platform_id: 1,
          term,
          page_no: 1,
          page_size: 50,
        },
      }),
    }),
    fetchSerachPublishers: build.query({
      query: (term) => ({
        url: `/GetSearchPublishers`,
        params: {
          platform_id: 1,
          term,
          page_no: 1,
          page_size: 50,
        },
      }),
    }),
    fetchSaveOptOut: build.mutation({
      query: (data) => ({
        url: `/SaveOptOut`,
        method: 'POST',
        data: {
          ...data,
          min_CPI: 0,
          new_campaign_assoc: 0,
          is_visible: 0,
          is_active: 0,
        },
      }),
      invalidatesTags: ['AppsManage/GetAppAdvancedData'],
    }),
    fetchSerachApplications: build.query({
      query: (term) => ({
        url: `/SearchExcludeApps`,
        params: {
          term,
        },
      }),
    }),
    fetchAppData: build.query({
      query: (pbaId) => ({
        url: `/GetAppData`,
        params: {
          pbaId,
        },
      }),
      providesTags: () => ['AppsManage/GeneralSettings'],
      transformResponse: (response) => addFieldStatus([response])[0],
    }),
    updateAppData: build.mutation({
      query: (data) => ({
        url: `/SaveExistingApp`,
        method: 'POST',
        data,
      }),
      invalidatesTags: [
        'AppsManage/GeneralSettings',
        'AppsManage/GetAppsToPromoteByFiltere',
        'AppsManage/GetPublisherApps',
      ],
    }),
    packageValidation: build.query({
      query: (pba_id) => ({
        url: `/PackageValidation`,
        params: {
          pba_id,
        },
      }),
    }),
    getAppDataExtendedFromStore: build.query({
      query: (pba_id) => ({
        url: `/GetAppDataExtendedFromStore`,
        params: {
          pba_id,
        },
      }),
    }),
    getAppStoreData: build.query({
      query: ({ packageName }) => ({
        url: `/GetAppStoreData`,
        params: {
          pba_id: 'const',
          package: packageName,
          platform: 'android',
          isFullUrl: true,
        },
      }),
    }),
    deleteApp: build.mutation({
      query: (data) => ({
        url: `/DeleteApp`,
        method: 'POST',
        params: {
          pba_id: data,
        },
      }),
      invalidatesTags: ['AppsManage/GetAppsToPromoteByFiltere', 'AppsManage/GetPublisherApps'],
    }),
    restoreApp: build.mutation({
      query: (data) => ({
        url: `/RestoreApp`,
        method: 'POST',
        params: {
          pba_id: data,
        },
      }),
      invalidatesTags: ['AppsManage/GetAppsToPromoteByFiltere', 'AppsManage/GetPublisherApps'],
    }),
    saveMinimumServing: build.mutation({
      query: (data) => ({
        url: `/SaveMinimumServing`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['AppsManage/GetAppAdvancedData'],
    }),
    getPlacements: build.query({
      query: (pbaId) => ({
        url: `/getPlacements`,
        params: {
          pbaId,
        },
      }),
      providesTags: () => ['AppsManage/GetPlacements'],
    }),
    createPlacement: build.mutation({
      query: ({ data, pba_id }) => ({
        url: `/CreatePlacement`,
        method: 'POST',
        data,
        params: {
          pba_id,
        },
      }),
      invalidatesTags: ['AppsManage/GetPlacements'],
    }),
    upDatePlacement: build.mutation({
      query: ({ data, pba_id }) => ({
        url: `/UpdatePlacementInfo`,
        method: 'POST',
        data,
        params: {
          pbaId: pba_id,
        },
      }),
      invalidatesTags: ['AppsManage/GetPlacements'],
    }),
    SaveAppInstallPostback: build.mutation({
      query: (data) => ({
        url: `/SaveAppInstallPostback`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['AppsManage/GetAppAdvancedData'],
    }),
    SaveAppEventPostback: build.mutation({
      query: (data) => ({
        url: `/SaveAppEventPostback`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['AppsManage/GetAppAdvancedData'],
    }),
    SaveAppRejectedInstallPostback: build.mutation({
      query: (data) => ({
        url: `/SaveAppRejectedInstallPostback`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['AppsManage/GetAppAdvancedData'],
    }),
    saveNewGoogleApp: build.mutation({
      query: (data) => ({
        url: `/SaveApp`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['AppsManage/GetAppsToPromoteByFiltere', 'AppsManage/GetPublisherApps'],
    }),
    checkPostbackUrl: build.mutation({
      query: (data) => ({
        url: `/CheckPostbackUrl`,
        method: 'POST',
        params: {
          postBackUrl: data,
        },
      }),
      invalidatesTags: ['AppsManage/GetAppsToPromoteByFiltere', 'AppsManage/GetPublisherApps'],
    }),
    getCountriesList: build.query({
      query: (term) => ({
        url: `/GetCountriesList`,
        params: {
          term,
        },
      }),
    }),
    getAllAppsCategories: build.query({
      query: () => ({
        url: `/GetAllAppsCategories`,
      }),
    }),
    saveUnpublishedApp: build.mutation({
      query: (data) => ({
        url: `/SaveUnpublishedApp`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['AppsManage/GetAppsToPromoteByFiltere', 'AppsManage/GetPublisherApps'],
    }),
    saveWebsiteApp: build.mutation({
      query: (data) => ({
        url: `/SaveWebsiteApp`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['AppsManage/GetAppsToPromoteByFiltere', 'AppsManage/GetPublisherApps'],
    }),
    validateWebsiteUrl: build.query({
      query: (url) => ({
        url: `/ValidateWebsiteUrl`,
        params: { url },
      }),
    }),
    fixAppUrl: build.mutation({
      query: (data) => ({
        url: `/FixApp`,
        method: 'POST',
        data,
      }),
      onQueryStarted: async (arg, { queryFulfilled, dispatch }) => {
        //invalidateTags only after successful
        try {
          const result = await queryFulfilled;
          console.log(result);
          dispatch(
            manageAppsAPI.util.invalidateTags([
              'AppsManage/GetAppsToPromoteByFiltere',
              'AppsManage/GetPublisherApps',
            ]),
          );
        } catch {
          console.log('server error');
        }
      },
    }),
  }),
});
